import React from 'react';
import PropTypes from 'prop-types';
import AccordionSection from './AccordionSection';
import { StyledAccordionTable } from './style';

const AccordionTable = ({ className, dataTable }) => (
  <StyledAccordionTable className={className}>
    {dataTable &&
      dataTable.map((section, i) => (
        <AccordionSection
          title={section.title}
          dataSection={section.dataSection}
          key={`section-${i + 1}`}
        />
      ))}
  </StyledAccordionTable>
);

AccordionTable.propTypes = {
  className: PropTypes.string,
  dataTable: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      dataSection: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string,
          body: PropTypes.string
        })
      )
    })
  )
};

export default AccordionTable;
